import { render, staticRenderFns } from "./DeleteCompetitorRenderer.vue?vue&type=template&id=28115e41&scoped=true&"
import script from "./DeleteCompetitorRenderer.vue?vue&type=script&lang=js&"
export * from "./DeleteCompetitorRenderer.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCompetitorRenderer.vue?vue&type=style&index=0&id=28115e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28115e41",
  null
  
)

/* custom blocks */
import block0 from "./DeleteCompetitorRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports